<template>
  <div class="popup-box">
    <div class="content">
      <header class="header">
        <span class="title">{{ title }}</span>
        <img
          class="icon"
          src="../assets/icon-close@2x.png"
          alt
          @click="hidePopup"
        />
      </header>
      <slot />
    </div>
  </div>
</template>


<script>
export default {
  name: 'Popup',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    hidePopup() {
      this.$emit('close', this);
    },
  },
};
</script>


<style lang="less" scoped>
.popup-box {
  position: fixed;
  z-index: 3;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  .content {
    width: 500px;
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 20px 20px;
    box-shadow: 0 0 4px 4px rgba(56, 56, 56, 0.74);
    .header {
      position: relative;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #eee;
      .title {
        width: auto;
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
      }
      .icon {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        zoom: 0.6;
        cursor: pointer;
      }
    }
  }
}
</style>
